module.exports = __webpack_public_path__ + "static/media/pagination-right-disabled.1d38edae.svg";